import styled from 'styled-components';
import { Button, Typography } from '~/components';
import { Icon, getTheme, ifStyle, pxToRem } from '~/modules';

const smSpacing = getTheme('spacing.sm');
const mdSpacing = getTheme('spacing.md');
const isFrontCamera = ifStyle('$isFrontCamera');

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  margin-bottom: ${mdSpacing}px;
`;

type VideoProps = {
  $isFrontCamera: boolean;
};

export const Video = styled.video<VideoProps>`
  width: 100%;
  object-fit: cover;
  background-color: black;
  transform: ${isFrontCamera('scaleX(-1)', 'scaleX(1)')};
  display: block;
  visibility: visible;
  position: relative;
`;

export const CaptureButton = styled(Button)``;

export const MessageContainer = styled.div`
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${smSpacing}px;
`;

export const Title = styled(Typography).attrs({
  variant: 'max',
})`
  font-weight: bold;
`;

export const SceneTitle = styled(Typography).attrs({
  variant: 'xl',
})`
  font-weight: bold;
  margin-inline: auto;
`;

export const Message = styled(Typography).attrs({
  variant: 'md',
})`
  line-height: 1.5;
  opacity: 0.7;
`;

export const RetryButton = styled(Button)``;

export const NextButton = styled(Button)``;

export const PreviewContainer = styled.div<VideoProps>`
  position: relative;
  width: 100%;
  margin-bottom: ${mdSpacing}px;
  flex: 1;
  transform: ${isFrontCamera('scaleX(-1)', 'scaleX(1)')};
`;

export const PreviewImage = styled.img`
  width: 100%;
  object-fit: cover;
`;

export const CustomFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${smSpacing}px;
  flex: 1;
`;

export const CameraIcon = styled(Icon).attrs({
  fontSize: pxToRem(18),
})`
  margin-right: ${smSpacing}px;
`;

export const ErrorIcon = styled(Icon).attrs({
  fontSize: pxToRem(96),
})`
  margin-bottom: ${mdSpacing}px;
  opacity: 0.5;
`;

export const MaskOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  pointer-events: none;
  height: 80%;
  max-width: 90%;
  width: auto;
`;
